import React from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../utils/analyticsUtils';
import './Navbar.css'; // Optional: add styles here

function Navbar() {
  const handleNavClick = (navItem) => {
    trackButtonClick(`Navbar-${navItem}`, 'Navbar');
  };

  return (
    <nav className="navbar">
      {/* <div className="navbar-logo">MySite</div> */}
      <ul className="navbar-links">
        <li><Link to="/" onClick={() => handleNavClick('Home')}>HOME</Link></li>
        <li><Link to="/projects" onClick={() => handleNavClick('Projects')}>PROJECTS</Link></li>
        <li><Link to="/resume" onClick={() => handleNavClick('Resume')}>RESUME</Link></li>
        <li><Link to="/journal" onClick={() => handleNavClick('Blog')}>BLOG</Link></li>
        <li><Link to="/shop" onClick={() => handleNavClick('Shop')}>SHOP</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
